document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('search-input');
  const liveResults = document.getElementById('live-search-results');
  const liveProducts = document.getElementById('live-search-products');
  const liveLoading = document.querySelector('.live-search-loading');
  const viewAllContainer = document.getElementById('live-search-view-all');
  const viewAllLink = document.querySelector('.view-all-link');
  const closeButtons = document.querySelectorAll('.close-search, .search-close, .close-search-icon, .close-menu');
  const openButtons = document.querySelectorAll('.search-toggle, .search-icon, .search-open, .search_icon_container');
  
  let searchTimeout;
  let currentQuery = '';

  if (!searchInput) return;

  // Show/hide results
  function showResults() {
    if (!liveResults) return;
    liveResults.style.display = 'flex';
    document.body.classList.add('search-results-open');

    requestAnimationFrame(() => {
      positionResults();
    });
  }

  function hideResults() {
    if (!liveResults) return;
    
    // Clear results content
    if (liveProducts) {
        liveProducts.innerHTML = '';
        liveProducts.style.maxHeight = '';
    }
    
    // Hide containers
    liveResults.style.display = 'none';
    if (viewAllContainer) {
        viewAllContainer.style.display = 'none';
    }
    
    // Reset all positioning
    liveResults.style.top = '';
    liveResults.style.maxHeight = '';
    liveResults.style.position = '';
    liveResults.style.left = '';
    liveResults.style.right = '';
    liveResults.style.bottom = '';

    // Reset body state
    document.body.classList.remove('search-results-open');
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    document.body.style.overflow = '';
  }

  function showLoading() {
    liveLoading.style.display = 'block';
    liveProducts.innerHTML = '';
    viewAllContainer.style.display = 'none';
    liveResults.style.display = 'none';
  }

  function hideLoading() {
    liveLoading.style.display = 'none';
  }

  if (closeButtons && closeButtons.length) {
  closeButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      searchInput.value = '';
      currentQuery = '';
      hideResults();
    });
  });
}

if (openButtons && openButtons.length) {
  openButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      searchInput.value = '';
      currentQuery = '';
      hideResults();
      setTimeout(() => {
        searchInput.focus();
      }, 50);
    });
  });
}

  function positionResults() {
    if (!searchInput || !liveResults) return;

    // use getBoundingClientRect so position follows input even when page is scrolled
    const rect = searchInput.getBoundingClientRect();
    const isMobile = window.innerWidth <= 991;
    const spacing = isMobile ? 14 : 19;
    const top = Math.max(rect.bottom, 0) + spacing; // px from viewport top
    const available = window.innerHeight - top; // space below input

    liveResults.style.position = 'fixed';
    liveResults.style.top = `${top}px`;
    liveResults.style.left = `0`;
    liveResults.style.right = `0`;
    // Set max-height for the container, leave internal scrolling to .live-search-products
    liveResults.style.maxHeight = `${available}px`;
    liveResults.style.bottom = 'auto';
    // Ensure products area can scroll inside available space (subtract any footer/view-all heights if needed)
    if (liveProducts) {
      // Reserve ~80px for view-all / paddings — adjust if necessary
      const reserved = (viewAllContainer && viewAllContainer.offsetHeight) ? viewAllContainer.offsetHeight : 80;
      liveProducts.style.maxHeight = `${Math.max(available - reserved, 100)}px`;
    }
  }

  // reposition while open on resize/scroll for responsive behavior
  window.addEventListener('resize', function() {
    if (liveResults.style.display === 'flex') positionResults();
  }, { passive: true });

  window.addEventListener('scroll', function() {
    if (liveResults.style.display === 'flex') positionResults();
  }, { passive: true });

  // Perform search
  function performSearch(query) {
    // Double-check the current input value matches the query
    const currentInputValue = searchInput.value.trim();
    
    if (!query || query.length < 2 || !currentInputValue || currentInputValue.length < 2) {
      currentQuery = '';
      hideResults();
      return;
    }

    // If the input has changed since this search was scheduled, abort
    if (query !== currentInputValue) {
      return;
    }

    currentQuery = query;
    showResults();
    showLoading();

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`)
      .then(response => response.json())
      .then(data => {
        // Check again if input is still valid before displaying results
        if (!searchInput.value.trim() || searchInput.value.trim() !== query) {
          hideLoading();
          hideResults();
          return;
        }
        
        hideLoading();
        
        if (data.resources && data.resources.results && data.resources.results.products) {
          displayResults(data.resources.results.products, query);
        } else {
          fetch(`/search?q=${encodeURIComponent(query)}&type=product&view=json`)
            .then(response => response.text())
            .then(html => {
              displayNoResults();
            })
            .catch(error => {
              console.error('Search error:', error);
              displayNoResults();
            });
        }
      })
      .catch(error => {
        console.error('Search error:', error);
        hideLoading();
        displayNoResults();
      });
  }

  // Sort products with bestsellers first (you'll need to implement bestseller logic)
function sortProductsWithBestsellers(products) {
  return products.sort((a, b) => {
    // Check if product has "Best Sellers" tag (case insensitive)
    const aIsBestseller = a.tags && a.tags.some(tag => 
      tag.toLowerCase() === 'best sellers' || tag.toLowerCase() === 'best seller'
    );
    const bIsBestseller = b.tags && b.tags.some(tag => 
      tag.toLowerCase() === 'best sellers' || tag.toLowerCase() === 'best seller'
    );
    
    // Bestsellers come first
    if (aIsBestseller && !bIsBestseller) return -1;
    if (!aIsBestseller && bIsBestseller) return 1;
    return 0;
  });
}

// Also update the displayResults function to use the same logic:
function displayResults(products, query) {
  if (!products || products.length === 0) {
    hideResults();
    return;
  }

  const autoDiscount = window.autoDiscountConfig || { active: false, percent: 0 };

  // Sort products with bestsellers first and limit to 4
  const sortedProducts = sortProductsWithBestsellers(products).slice(0, 4);
  let html = '';

  sortedProducts.forEach((product, index) => {
    // Check for "Best Sellers" tag
    const isBestseller = product.tags && product.tags.some(tag => 
      tag.toLowerCase() === 'best sellers' || tag.toLowerCase() === 'best seller'
    );

    let price = product.price ? Math.round(Number(product.price)) : '';
    let comparePrice = product.compare_at_price && Number(product.compare_at_price) > Number(product.price)
      ? Math.round(Number(product.compare_at_price))
      : null;

    // Apply auto-discount if active
    const isDiscountEligible = autoDiscount.active
      && autoDiscount.percent > 0
      && (autoDiscount.allProducts || (product.handle && autoDiscount.eligibleHandles.includes(product.handle)));

    if (isDiscountEligible && price) {
      const originalPrice = price;
      const originalCompareAt = comparePrice;

      if (!originalCompareAt || originalCompareAt <= originalPrice) {
        const discountMultiplier = (100 - autoDiscount.percent) / 100;
        comparePrice = originalPrice;
        price = Math.round(originalPrice * discountMultiplier);
      }
    }

    // Calculate discount percentage for display
    let discountPercent = '';
    if (comparePrice && comparePrice > price) {
      const discount = Math.round(((comparePrice - price) / comparePrice) * 100);
      discountPercent = `<span style="background: #ffdaca; margin-left: 10px; padding: 2px 5px; font-size: 14px;">${discount}% off</span>`;
    }

    html += `
      <a href="${product.url}" class="live-search-product">
        <div class="live-search-product-image">
          <img src="${(product.image && product.image.src) ? product.image.src : (product.image ? product.image : '/assets/no-image.png')}" 
               alt="${product.title}" 
               loading="lazy">
        </div>
        <div class="live-search-product-info">
          <div class="best-seller-holder">
            ${isBestseller ? '<p class="ribbon-subhead">Best Seller</p>' : ''}
          </div>
          <h4 class="live-search-product-title">
            ${product.title}
          </h4>
          <p class="live-search-product-price">
            ${comparePrice ? `<span style="text-decoration: line-through; color: #999; font-size: 18px;">$${comparePrice}</span> ` : ''}
            ${price ? `<span style="color: ${comparePrice ? '#db3d3e' : 'inherit'}; font-weight: ${comparePrice ? '600' : 'normal'};">$${price}</span>` : 'Price unavailable'}
            ${discountPercent}
          </p>
        </div>
      </a>
    `;
  });

  liveProducts.innerHTML = html;
  liveResults.style.display = 'flex';

  // Show "View all results" link
  viewAllLink.href = `/search?type=product&q=${encodeURIComponent(query)}`;
  viewAllContainer.style.display = 'block';

  // Reposition after content is added
  requestAnimationFrame(() => {
    positionResults();
  });
}

  function displayNoResults() {
  hideResults();
  }

  // Event listeners
  searchInput.addEventListener('input', function(e) {
    const query = e.target.value.trim();
    
    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // If empty, immediately hide results
    if (!query) {
      currentQuery = '';
      hideResults();
      return;
    }

    // Debounce search
    searchTimeout = setTimeout(() => {
      performSearch(query);
    }, 300);
  });

  searchInput.addEventListener('focus', function() {
    const query = searchInput.value.trim();
    
    // Only show results if there's a valid query with results
    if (query && query.length >= 2 && currentQuery && currentQuery.length >= 2 && liveProducts.children.length > 0) {
      showResults();
    }
  });

  // Hide results when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.search-holder')) {
      hideResults();
    }
  });

  // Prevent form submission when clicking on results
  liveResults.addEventListener('click', function(e) {
    e.stopPropagation();
  });

  let previousWidth = window.innerWidth;

window.addEventListener('resize', function() {
  const currentWidth = window.innerWidth;
  
  // Check if we crossed the 991px breakpoint
  if ((previousWidth <= 991 && currentWidth > 991) || (previousWidth > 991 && currentWidth <= 991)) {
    hideResults();
    searchInput.value = '';
    currentQuery = '';
  }
  
  // Normal repositioning if results are open
  if (liveResults.style.display === 'flex') positionResults();
  
  previousWidth = currentWidth;
}, { passive: true });
});